<template>
    <footer class="common-footer">
        <div class="common-footer__container">
            <div class="common-footer__wrapper">
                <div class="common-footer__logo-wrap">
                    <a class="common-footer__logo"
                       href="/"
                    >
                        <ui-logo-text
                            use-current-color
                            second-color="#9155EB"
                            big
                        />
                    </a>
                </div>
                <div class="common-footer__subscription">
                    <common-footer-subscription />
                </div>
                <div class="common-footer__info">
                    <common-footer-collapsable
                        title="Информация"
                        v-model="isInfoCollapsed"
                        >
                        <common-footer-info />
                    </common-footer-collapsable>
                </div>
                <div class="common-footer__contacts">
                    <common-footer-collapsable
                        title="Контакты"
                        v-model="isContactsCollapsed"
                        >
                        <common-footer-contacts />
                    </common-footer-collapsable>
                </div>
                <div class="common-footer__documents"
                    v-if="documents"
                    >
                    <common-footer-collapsable
                        title="Документы"
                        v-model="isDocumentsCollapsed"
                        >
                        <common-footer-documents v-bind:documents="documents" />
                    </common-footer-collapsable>
                </div>
                <div class="common-footer__line"></div>
                <div class="common-footer__register">
                    <div class="common-footer__register-operator">
                        <div class="common-footer__register-text">
                            Платформа состоит в <a v-bind:href="urls.register" target="_blank">Реестре операторов инвестиционных платформ ЦБ&nbsp;РФ</a>
                        </div>
                        <a class="common-footer__register-icon"
                           v-bind:href="urls.bank"
                           target="_blank"
                        >
                            <img v-bind:src="require('/static/images/bank-logo.png')" height="30" alt="" />
                        </a>
                    </div>
                </div>
                <div class="common-footer__copyright">
                    © {{ new Date().getFullYear() }} Все права защищены
                </div>
                <div class="common-footer__development">
                    Дизайн и разработка: <a class="common-footer__development-link"
                        v-bind:href="urls.initflow"
                        target="_blank"
                        >Initflow</a>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
import config from '~/config';

export default {
    name: 'common-footer',
    props: {
        documents: {
            type: Array,
            default: null,
        },
    },
    data: () => ({
        isInfoCollapsed: true,
        isContactsCollapsed: true,
        isDocumentsCollapsed: true,
    }),
    computed: {
        urls() {
            return {
                register: config.urls.footer.register,
                bank: config.urls.footer.bank,
                initflow: 'https://initflow.com',
            };
        },
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.common-footer {
    .typography-body();

    color: @color-gray-light;

    background-color: @color-gray-darker;
    &__container {
        .container();
    }
    &__wrapper {
        display: grid;
        column-gap: @grid-gap;
        grid-template-columns: repeat(12, 1fr);
        padding-top: 74px;
        padding-bottom: 74px;
    }
    &__logo-wrap {
        grid-row: 1;
        grid-column: ~'1 / 13';
        padding-bottom: 32px;
        margin-bottom: 32px;
        border-bottom: 1px solid @color-gray-main;
    }
    &__logo {
        .typography-medium();

        text-decoration: none;
    }
    &__subscription {
        grid-row: ~'2 / 3';
        grid-column: ~'9 / 13';
    }
    &__info {
        grid-row: 2;
        grid-column: ~'1 / 6';
        margin-bottom: 32px;
    }
    &__contacts {
        grid-row: 2;
        grid-column: ~'6 / 7';
        margin-bottom: 32px;
    }
    &__documents {
        grid-row: 2;
        grid-column: ~'7 / 9';
        margin-bottom: 32px;
    }
    &__line {
        grid-row: 3;
        grid-column: ~'1 / 13';
        // padding-bottom: 32px;
        margin-bottom: 32px;
        border-bottom: 1px solid @color-gray-main;
        &._mobile {
             display: none;
        }
    }
    &__register {
        grid-row: 4;
        grid-column: ~'1 / 7';
        align-self: center;
        display: flex;
        flex-direction: column;
        // align-items: center;
        justify-content: flex-start;
        gap: 12px;
        color: @color-gray-main;
        &-operator {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            gap: 22px;
        }
        &-icon {
            display: block;
            flex-shrink: 0;
            // margin-right: 12px;

            // filter: grayscale(100%);
        }
        &-text {
             // flex: 1 1 auto;
        }
    }
    &__copyright {
        grid-row: 4;
        grid-column: ~'7 / 11';
        align-self: center;
        color: @color-gray-main;
    }
    &__development {
        grid-row: 4;
        grid-column: ~'11 / 13';
        align-self: center;

        text-align: right;
        color: @color-gray-main;
        &-link {
            font-weight: 600;
            text-decoration: none;
            text-transform: uppercase;
            &:hover {
                text-decoration: underline;
            }
        }
    }
    @media @media-lg-down {
        &__info {
            grid-column: ~'1 / 5';
        }
        &__contacts {
            grid-column: ~'5 / 7';
        }
        &__documents {
            grid-column: ~'7 / 9';
        }
        &__register {
            grid-column: ~'1 / 5';
            &-operator {
                align-items: flex-start;
                flex-direction: column;
                gap: 8px;
            }
        }
        &__copyright {
            grid-column: ~'6 / 9';
        }
        &__development {
            grid-column: ~'10 / 13';
        }
    }
    @media @media-md-down {
        &__wrapper {
            grid-template-columns: repeat(7, 1fr);
        }
        &__logo-wrap, &__line {
            grid-column: ~'1 / 8';
        }
        &__line {
            grid-row: 4;
        }
        &__logo {
            grid-column: ~'1 / 8';
        }
        &__subscription {
            // grid-row: ~'3 / 7';
            grid-row: 3;
            grid-column: ~'2 / 7';
            margin-bottom: 32px;
        }
        &__info {
            grid-column: ~'1 / 4';
        }
        &__contacts {
            grid-column: ~'4 / 6';
        }
        &__documents {
            grid-column: ~'6 / 8';
        }
        &__copyright {
            grid-row: 5;
            grid-column: ~'4 / 6';
            align-self: flex-start;
            margin-bottom: 24px;
        }
        &__register {
            grid-row: 5;
            grid-column: ~'1 / 4';
            align-self: flex-start;
            margin-bottom: 24px;
        }
        &__development {
            grid-row: 5;
            grid-column: ~'6 / 8';
            align-self: flex-start;
            margin-bottom: 16px;

            text-align: left;
        }
    }
    @media @media-xs-down {
        &__wrapper {
            grid-template-columns: 1fr;
            justify-items: center;

            padding-top: 40px;
            padding-bottom: 40px;

            text-align: center;
        }
        &__logo {
            grid-column: 1;
        }
        &__logo-wrap, &__line {
            width: 100%;
            grid-column: 1;
            margin-bottom: 24px;
        }
        &__subscription {
            grid-row: 2;
            grid-column: 1;
            margin-bottom: 24px;
        }
        &__info {
            width: 100%;
            grid-column: 1;
            grid-row: 3;
            margin-bottom: 24px;
            border-top: 1px solid @color-gray-main;
            padding-top: 24px;
        }
        &__contacts {
            width: 100%;
            grid-column: 1;
            grid-row: 4;
            margin-bottom: 24px;
        }
        &__documents {
            width: 100%;
            grid-column: 1;
            grid-row: 5;
            margin-bottom: 24px;
        }
        &__line {
            grid-row: 6;
        }
        &__copyright {
            grid-column: 1;
            grid-row: 8;
            margin-bottom: 16px;
        }
        &__register {
            grid-column: 1;
            grid-row: 7;
            margin-bottom: 16px;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            &-icon {
                margin-right: 0;
                margin-bottom: 8px;
            }
            &-operator {
                align-items: center;
                flex-direction: column-reverse;
                gap: 0;
            }
        }
        &__development {
            grid-column: 1;
            grid-row: 9;
            margin-bottom: 0;
        }
    }
}
</style>
